
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect,useState } from 'react';
import { _postURL } from '@/api/index';
import Redux, { updatePath } from "@/action";
import { LoaderFull } from '@/components/loader';
import _, { unset } from 'lodash';
import { VehicleBrands } from '@/components/vehicle/brands';
import { VehicleModel } from '@/components/vehicle/model';
import { VehicleVariant } from '@/components/vehicle/variant';
import { VehicleFilter } from '@/components/vehicle/filter';
import { VehicleFilterResult } from '@/components/vehicle/filterResult';
import { VehicleGallery } from '@/components/vehicle/gallery';
import { VehicleReview } from '@/components/vehicle/review';
import { VehicleWriteReview } from '@/components/vehicle/writeReview';
import { VehicleAuthor } from '@/components/vehicle/author';
import { VehicleNews } from '@/components/vehicle/news';
import { VehicleSpec } from '@/components/vehicle/spec';
import { useRouter } from 'next/router';
import { pageLink } from '@/config/site';
import { getCookies, hasCookie } from 'cookies-next';
import { priceOption } from '../../config/site';

export default function Index(props) {
    const { store, dispatch } = Redux();
    const { t, device, session, params, fetchedData } = props;
    const [loading, setLoading] = useState(false);
    const router = useRouter()

    if( // variant gallery page
        params?.vehicle?.length === 4 
        && params?.vehicle?.[0] != "filter" 
        && params?.vehicle?.[1] != "result" 
        && params?.vehicle?.[2] != "gallery" 
        && params?.vehicle?.[2] != "review" 
        && params?.vehicle?.[2] != "write-review"
        && params?.vehicle?.[2] != "author"
        && params?.vehicle?.[2] != "news"
        && params?.vehicle?.[2] != "video"
        && params?.vehicle?.[2] != "spec"
        && params?.vehicle?.[3] == "gallery"
        && !_.isEmpty(fetchedData)
    ){
        return <VehicleGallery {...props} />
    } else if( // model author page
        params?.vehicle?.length === 4 
        && params?.vehicle?.[0] != "filter" 
        && params?.vehicle?.[1] != "result" 
        && params?.vehicle?.[2] != "gallery" 
        && params?.vehicle?.[2] != "review" 
        && params?.vehicle?.[2] != "write-review"
        && params?.vehicle?.[2] == "author"
        && params?.vehicle?.[2] != "news"
        && params?.vehicle?.[2] != "video"
        && params?.vehicle?.[2] != "spec"
        && params?.vehicle?.[3] != "gallery"
        && !_.isEmpty(fetchedData)
    ){
        return <VehicleAuthor {...props} />
    } else if( // model gallery page
        params?.vehicle?.length === 3
        && params?.vehicle?.[0] != "filter" 
        && params?.vehicle?.[1] != "result" 
        && params?.vehicle?.[2] == "gallery" 
        && params?.vehicle?.[2] != "review" 
        && params?.vehicle?.[2] != "write-review"
        && params?.vehicle?.[2] != "author"
        && params?.vehicle?.[2] != "news"
        && params?.vehicle?.[2] != "video"
        && params?.vehicle?.[2] != "spec"
        && !_.isEmpty(fetchedData)
    ){
        return <VehicleGallery {...props} />
    } else if( // model review page
        params?.vehicle?.length === 3
        && params?.vehicle?.[0] != "filter" 
        && params?.vehicle?.[1] != "result" 
        && params?.vehicle?.[2] != "gallery" 
        && params?.vehicle?.[2] == "review" 
        && params?.vehicle?.[2] != "write-review"
        && params?.vehicle?.[2] != "author"
        && params?.vehicle?.[2] != "news"
        && params?.vehicle?.[2] != "video"
        && params?.vehicle?.[2] != "spec"
        && !_.isEmpty(fetchedData)
    ){
        return <VehicleReview {...props} />
    } else if( // model write-review page
        params?.vehicle?.length === 3
        && params?.vehicle?.[0] != "filter" 
        && params?.vehicle?.[1] != "result" 
        && params?.vehicle?.[2] != "gallery" 
        && params?.vehicle?.[2] != "review" 
        && params?.vehicle?.[2] == "write-review"
        && params?.vehicle?.[2] != "author"
        && params?.vehicle?.[2] != "news"
        && params?.vehicle?.[2] != "video"
        && params?.vehicle?.[2] != "spec"
        && !_.isEmpty(fetchedData)
    ){
        return <VehicleWriteReview {...props} />
    } else if( // model news page
        params?.vehicle?.length === 3
        && params?.vehicle?.[0] != "filter" 
        && params?.vehicle?.[1] != "result" 
        && params?.vehicle?.[2] != "gallery" 
        && params?.vehicle?.[2] != "review" 
        && params?.vehicle?.[2] != "write-review"
        && params?.vehicle?.[2] != "author"
        && params?.vehicle?.[2] == "news"
        && params?.vehicle?.[2] != "video"
        && params?.vehicle?.[2] != "spec"
        && !_.isEmpty(fetchedData)
    ){
        return <VehicleNews {...props} type={"1"} />
    } else if( // model video page
        params?.vehicle?.length === 3
        && params?.vehicle?.[0] != "filter" 
        && params?.vehicle?.[1] != "result" 
        && params?.vehicle?.[2] != "gallery" 
        && params?.vehicle?.[2] != "review" 
        && params?.vehicle?.[2] != "write-review"
        && params?.vehicle?.[2] != "author"
        && params?.vehicle?.[2] != "news"
        && params?.vehicle?.[2] == "video"
        && params?.vehicle?.[2] != "spec"
        && !_.isEmpty(fetchedData)
    ){
        return <VehicleNews {...props} type={"2,3"} />
    } else if( // model spec page
        params?.vehicle?.length === 3
        && params?.vehicle?.[0] != "filter" 
        && params?.vehicle?.[1] != "result" 
        && params?.vehicle?.[2] != "gallery" 
        && params?.vehicle?.[2] != "review" 
        && params?.vehicle?.[2] != "write-review"
        && params?.vehicle?.[2] != "author"
        && params?.vehicle?.[2] != "news"
        && params?.vehicle?.[2] != "video"
        && params?.vehicle?.[2] == "spec"
        && !_.isEmpty(fetchedData)
    ){
        return <VehicleSpec {...props} />
    } else if( // variant page
        params?.vehicle?.length === 3
        && params?.vehicle?.[0] != "filter" 
        && params?.vehicle?.[1] != "result" 
        && params?.vehicle?.[2] != "gallery" 
        && params?.vehicle?.[2] != "review" 
        && params?.vehicle?.[2] != "write-review"
        && params?.vehicle?.[2] != "author"
        && params?.vehicle?.[2] != "news"
        && params?.vehicle?.[2] != "video"
        && params?.vehicle?.[2] != "spec"
        && !_.isEmpty(fetchedData)
    ){
        return <VehicleVariant {...props} />
    } else if( // filter result page
        params?.vehicle?.length === 2
        && params?.vehicle?.[0] == "filter" 
        && params?.vehicle?.[1] == "result" 
        && !_.isEmpty(fetchedData)
    ){
        return <VehicleFilterResult {...props} />
    } else if( // model page
        params?.vehicle?.length === 2
        && params?.vehicle?.[0] != "filter" 
        && params?.vehicle?.[1] != "result"
        && !_.isEmpty(fetchedData)
    ){
        return <VehicleModel {...props} />
    } else if( // filter page
        params?.vehicle?.length === 1
        && params?.vehicle?.[0] == "filter" 
    ){
        return <VehicleFilter {...props} />
    } else if( // brand page
        params?.vehicle?.length === 1
        && params?.vehicle?.[0] != "filter" 
        && !_.isEmpty(fetchedData)
    ){
        return <VehicleBrands {...props} />
    } else {
        return <>404 page</>
    }
}

export async function getServerSideProps ({ req, res, locale, params, query }) {
    
    try {
        let fetchedData = null;
        if(
            params?.vehicle?.length === 4
            && params?.vehicle?.[0] != "filter" 
            && params?.vehicle?.[1] != "result" 
            && params?.vehicle?.[2] != "gallery" 
            && params?.vehicle?.[2] != "review" 
            && params?.vehicle?.[2] != "write-review"
            && params?.vehicle?.[2] != "author"
            && params?.vehicle?.[2] != "news"
            && params?.vehicle?.[2] != "video"
            && params?.vehicle?.[2] != "spec"
            && params?.vehicle?.[3] == "gallery"
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getAllImageGallery`, { brand_custom_url: params?.vehicle[0], model_custom_url: params?.vehicle[1], variant_custom_url: params?.vehicle[2]})
            ]);
            fetchedData = data ?? {}
        } else if(
            params?.vehicle?.length === 4 
            && params?.vehicle?.[0] != "filter" 
            && params?.vehicle?.[1] != "result" 
            && params?.vehicle?.[2] != "gallery" 
            && params?.vehicle?.[2] != "review" 
            && params?.vehicle?.[2] != "write-review"
            && params?.vehicle?.[2] == "author"
            && params?.vehicle?.[2] != "news"
            && params?.vehicle?.[2] != "video"
            && params?.vehicle?.[2] != "spec"
            && params?.vehicle?.[3] != "gallery"
        ){
            const [
                { value: { data: vehicleData } },
                { value: { data: authorData } }
            ] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getModelDetail`, { brand_custom_url: params?.vehicle[0], model_custom_url: params?.vehicle[1] }),
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/author/getAuthorDetail`, { id: params?.vehicle[3] })
            ]);

            if(_.isEmpty(authorData)){
                throw new Error()
            }
            if(authorData?.role == 1 && authorData?.access_group == 1){
                throw new Error()
            }
            fetchedData = {vehicleData, authorData} ?? {}
        } else if(
            params?.vehicle?.length === 3
            && params?.vehicle?.[0] != "filter" 
            && params?.vehicle?.[1] != "result" 
            && params?.vehicle?.[2] == "gallery" 
            && params?.vehicle?.[2] != "review" 
            && params?.vehicle?.[2] != "write-review"
            && params?.vehicle?.[2] != "author"
            && params?.vehicle?.[2] != "news"
            && params?.vehicle?.[2] != "video"
            && params?.vehicle?.[2] != "spec"
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getAllImageGallery`, { brand_custom_url: params?.vehicle[0], model_custom_url: params?.vehicle[1] })
            ]);
            fetchedData = data ?? {}
        } else if(
            params?.vehicle?.length === 3
            && params?.vehicle?.[0] != "filter" 
            && params?.vehicle?.[1] != "result" 
            && params?.vehicle?.[2] != "gallery" 
            && params?.vehicle?.[2] == "review" 
            && params?.vehicle?.[2] != "write-review"
            && params?.vehicle?.[2] != "author"
            && params?.vehicle?.[2] != "news"
            && params?.vehicle?.[2] != "video"
            && params?.vehicle?.[2] != "spec"
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getModelDetail`, { brand_custom_url: params?.vehicle[0], model_custom_url: params?.vehicle[1] })
            ]);
            fetchedData = data ?? {}
        } else if(
            params?.vehicle?.length === 3
            && params?.vehicle?.[0] != "filter" 
            && params?.vehicle?.[1] != "result" 
            && params?.vehicle?.[2] != "gallery" 
            && params?.vehicle?.[2] != "review" 
            && params?.vehicle?.[2] == "write-review"
            && params?.vehicle?.[2] != "author"
            && params?.vehicle?.[2] != "news"
            && params?.vehicle?.[2] != "video"
            && params?.vehicle?.[2] != "spec"
        ){
            if(_.isEmpty(getCookies({ req, res })?.user)){
                // if no login throw error
                throw new Error()
            }
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getModelDetail`, { brand_custom_url: params?.vehicle[0], model_custom_url: params?.vehicle[1] })
            ]);
            fetchedData = data ?? {}
        } else if(
            params?.vehicle?.length === 3
            && params?.vehicle?.[0] != "filter" 
            && params?.vehicle?.[1] != "result" 
            && params?.vehicle?.[2] != "gallery" 
            && params?.vehicle?.[2] != "review" 
            && params?.vehicle?.[2] != "write-review"
            && params?.vehicle?.[2] != "author"
            && params?.vehicle?.[2] == "news"
            && params?.vehicle?.[2] != "video"
            && params?.vehicle?.[2] != "spec"
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getModelDetail`, { brand_custom_url: params?.vehicle[0], model_custom_url: params?.vehicle[1] })
            ]);
            fetchedData = data ?? {}
        } else if(
            params?.vehicle?.length === 3
            && params?.vehicle?.[0] != "filter" 
            && params?.vehicle?.[1] != "result" 
            && params?.vehicle?.[2] != "gallery" 
            && params?.vehicle?.[2] != "review" 
            && params?.vehicle?.[2] != "write-review"
            && params?.vehicle?.[2] != "author"
            && params?.vehicle?.[2] != "news"
            && params?.vehicle?.[2] == "video"
            && params?.vehicle?.[2] != "spec"
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getModelDetail`, { brand_custom_url: params?.vehicle[0], model_custom_url: params?.vehicle[1] })
            ]);
            fetchedData = data ?? {}
        } else if(
            params?.vehicle?.length === 3
            && params?.vehicle?.[0] != "filter" 
            && params?.vehicle?.[1] != "result" 
            && params?.vehicle?.[2] != "gallery" 
            && params?.vehicle?.[2] != "review" 
            && params?.vehicle?.[2] != "write-review"
            && params?.vehicle?.[2] != "author"
            && params?.vehicle?.[2] != "news"
            && params?.vehicle?.[2] != "video"
            && params?.vehicle?.[2] == "spec"
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getAllVehicleVariant`, { brand_custom_url: params?.vehicle[0], model_custom_url: params?.vehicle[1], not_on_sale: true })
            ]);
            fetchedData = data ?? {}
        } else if(
            params?.vehicle?.length === 3
            && params?.vehicle?.[0] != "filter" 
            && params?.vehicle?.[1] != "result" 
            && params?.vehicle?.[2] != "gallery" 
            && params?.vehicle?.[2] != "review" 
            && params?.vehicle?.[2] != "write-review"
            && params?.vehicle?.[2] != "author"
            && params?.vehicle?.[2] != "news"
            && params?.vehicle?.[2] != "video"
            && params?.vehicle?.[2] != "spec"
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getVariantDetail`, { brand_custom_url: params?.vehicle[0], model_custom_url: params?.vehicle[1], variant_custom_url: params?.vehicle[2] })
            ]);
            fetchedData = data ?? {}
        } else if(
            params?.vehicle?.length === 2
            && params?.vehicle?.[0] == "filter" 
            && params?.vehicle?.[1] == "result" 
        ){
            fetchedData = {}
            var queryLength = Object.keys(query).length;
            var request = queryLength == 1 ? {} : query;    // check query string, if have query string, then use query string, else pass empty for all result
            if(!_.isEmpty(query?.price)){
                let priceArray = _.split(query?.price, ',')
                const matchingValues = _.chain(priceOption)
                .filter(option => priceArray.includes(option.label))
                .map('value')
                .value();
                request = {...request, "price": matchingValues }
            }
            const [
                { value: { data: filterResult } },
                { value: { data: vehicleBrandList } }
            ] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getFilterResultInitialData`, request),
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getAllVehicleBrandList`, {})
            ]);
            fetchedData = {filterResult, vehicleBrandList, request} ?? {}
        } else if(
            params?.vehicle?.length === 2
            && params?.vehicle?.[0] != "filter" 
            && params?.vehicle?.[1] != "result"
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getModelDetail`, { brand_custom_url: params?.vehicle[0], model_custom_url: params?.vehicle[1] })
            ]);
            fetchedData = data ?? {}
        } else if(
            params?.vehicle?.length === 1
            && params?.vehicle?.[0] == "filter" 
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getFilterInitialData`)
            ]);
            fetchedData = data ?? {}
        } else if(
            params?.vehicle?.length === 1
            && params?.vehicle?.[0] != "filter" 
        ){
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getBrandDetail`, { brand_custom_url: params?.vehicle[0] })
            ]);
            fetchedData = data ?? {}
        } else {
            throw new Error();
        }

        if (_.isEmpty(fetchedData) && params?.vehicle?.[0] != "filter" ) throw new Error();

        return {
            props: {
                ...(await serverSideTranslations(locale, ['common'])),
                fetchedData,
                params,
                query
            },
        };
    } catch (error) {
        return {
            notFound: true,
        }
    }
}